import { AbstractCalendarController, AbstractDateRanger, setCalendarControllerSymbols } from '../../generated'

export default AbstractCalendarController

/** @constructor @extends {AbstractCalendarController} @suppress {checkTypes} */ function _CalendarController() {}
AbstractCalendarController.__implement(
 AbstractDateRanger,
 _CalendarController.prototype = /** @type {!AbstractCalendarController} */ ({
  __$constructor() {
   let today = new Date()
   today = new Date(today.getFullYear(),today.getMonth(),today.getDate())
   setCalendarControllerSymbols(this, {
    _today: today,
   })
  },
  // hasPrevMonth() {
  //   let today = new Date()
  //   const{
  //     state:{year,month},
  //   }=this
  //   let res=true
  //   const todayYear=today.getFullYear()
  //   const todayMonth=today.getMonth()
  //   if(year<todayYear) {
  //     // return false
  //     res=false
  //   } else if(year>todayYear) {
  //     res=true
  //   } else if(todayMonth==month) {
  //     res=false
  //   }
  //   console.log('hasPrevMonth',res, todayYear, todayMonth)
  //   return res
  //   // if(today.getMon)
  // },
  // initialiser() {
  //   debugger
  // },
 }),
)
